import React, { useState, useEffect, useRef } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CardContent,
    Button
} from '@material-ui/core';
import axios from '../../api';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/js/dataTables.dataTables.min.js';
import 'datatables.net/js/jquery.dataTables';
import Swal from "sweetalert2";
import VisualizarUnidade from "../Actions/VisualizarUnidade";
import ExcluirUnidade from "../Actions/ExcluirUnidade";
import EditarUnidade from "../Actions/EditarUnidade";

const columns = [
    { id: 'id', label: 'Protocolo'},
    { id: 'descricao', label: 'Descrição'},
    { id: 'sigla', label: 'Sigla',  width: '10%' },
    { id: 'created_at', label: 'Data cadastro'},
    { id: 'acoes', label: 'Ações' },
];

function TabelaUnidade() {
    const [results, setTableData ] = useState([]);
    const tableRef = useRef(null);
    const [updated, setUpdated] = useState(false);
    const [observacao, setObservacao] = useState("");

    useEffect(() => {
        Swal.fire({
            title: 'Carregando...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        axios.get('/unidade')
            .then(response => {
                const results = response.data.data;
                setTableData(results);

                // Verifique se o DataTable já foi inicializado na tabela
                const table = $('#unidades').DataTable();
                if ($.fn.DataTable.isDataTable('#unidades')) {
                    table.destroy();
                }

                // Inicialize o DataTable aqui
                $(document).ready(function() {
                    $('#unidades').DataTable({
                        language: {
                            url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Portuguese-Brasil.json'
                        },
                        deferRender: true,
                        destroy: true // adicione essa opção
                    });
                });
            })
            .catch(error => {
               // console.log(error);
            })
            .finally(() => {
                Swal.close();
            });
    }, [setTableData]);

    function fetchTableData() {
        const token = localStorage.getItem('token');
        axios.get('/unidade', { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                const results = response.data.data;
                setTableData(results);
            })
            .catch(error => {
                console.log(error)
            });
    }


    useEffect(() => {
        if (tableRef.current) {
            $(tableRef.current).DataTable();
        }
    }, [results]);


    function AtualizarTabela(id) {
        handleDelete(id)
    }

    const handleDelete = (id) => {
        const token = localStorage.getItem('token');

        axios.delete(`/unidade/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                // exibe mensagem de sucesso com cor verde
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: response.data.message,
                });

                // Atualiza o estado de atualização da tabela
                setUpdated(!updated);

                // Atualiza o estado da tabela removendo o item excluído
                setTableData(prevResults => prevResults.filter(result => result.id !== id));
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response.data.error,
                });
            });
    };


   // exclui a undiade

    return (

        <TableContainer component={Paper}>
            <CardContent>
                <Table id="unidades" ref={tableRef}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell id={"header"} key={column.id}  style={{ width: column.width }}>{column.label}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results.map((result) => (
                            <TableRow key={result.id}>
                                <TableCell>{result.id}</TableCell>
                                <TableCell>{result.descricao}</TableCell>
                                <TableCell>{result.sigla}</TableCell>
                                <TableCell>{result.created_at}</TableCell>
                                <TableCell>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        margin: '0 auto',
                                        padding: 2

                                    }}>
                                        <VisualizarUnidade
                                            id={Number(result.id)}
                                            title="Detalhes"
                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/unidade/show/`}
                                        />
                                        <EditarUnidade
                                            id={Number(result.id)}
                                            title="Editar"
                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/unidade/show/`}
                                            fetchTableData={fetchTableData}
                                        />
                                        <ExcluirUnidade
                                            id={Number(result.id)}
                                            title="Excluir"
                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/unidade/`}
                                            AtualizarTabela={AtualizarTabela}
                                        />
                                    </div>

                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>

                </Table>
            </CardContent>
        </TableContainer>

    );
}

export default TabelaUnidade;
